// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useMemo, useState } from 'react';
import { MDBContainer } from 'mdbreact';
import { connect } from 'react-redux';
import getCompaniesList from '../../utils/api/get/getCompaniesList';
import { toggleModal } from '../../storage/actions/modalsActions';
import Tablet from '../layout/tablet';
import { datatableManagerCompaniesColumnsForSuperAdmin as baseColumns } from '../../utils/constans';
import CompanyActions from './CompanyActions';

const buildColumns = (openCompanyUsers) => baseColumns.map((col) => {
  if (col.value === 'authToken') {
    return {
      ...col,
      className: 'auth-text subpage-mono',
      format: (value) => (
        <span className="ellipsis" title={value || ''}>
          {value || '—'}
        </span>
      ),
    };
  }
  if (col.value === 'name') {
    return {
      ...col,
      format: (value, item) => (
        <>
          <button
            type="button"
            className="company-name-link"
            onClick={() => openCompanyUsers(item)}
          >
            {value}
          </button>
          {item.suspended ? <span className="company-suspended-tag">Suspended</span> : null}
        </>
      ),
    };
  }
  return col;
});

const Content = ({
  isReload,
  toggleModal,
}) => {
  const [companies, setCompanies] = useState([]);
  const [sortBy, setSortBy] = useState({
    value: 'name',
    direction: 1,
  });

  const fetchCompaniesList = async () => {
    toggleModal(true, 'loader');
    const newCompaniesList = await getCompaniesList(sortBy);
    setCompanies(newCompaniesList);
    toggleModal(false, 'loader');
  };

  useEffect(() => {
    fetchCompaniesList();
  }, [isReload, sortBy]);

  const openCompanyUsers = (company) => {
    toggleModal(true, 'companyUsersModal', false, { company });
  };

  const columns = useMemo(() => buildColumns(openCompanyUsers), []);

  const handlerSort = item => {
    if (item.value === sortBy.value) {
      return setSortBy({
        ...sortBy,
        direction: sortBy.direction * -1,
      });
    }
    return setSortBy({
      value: item.value,
      direction: 1,
    });
  };

  return (
    <div className="subpage-table-scroll subpage-table-scroll--admin-companies">
      <Tablet
        className="subpage-table subpage-table--admin-companies"
        columns={columns}
        rows={companies}
        enableActionsCol
        sortBy={sortBy}
        handlerSort={handlerSort}
        ActionElement={CompanyActions}
        actionsColLabel="Actions"
        placeholder="Companies not found"
      />
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
};

const mapStateToProps = state => ({
  isReload: state.applicationState.isReload,
});

export default connect(mapStateToProps, mapDispatchToProps)(Content);
